(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pgnParser", [], factory);
	else if(typeof exports === 'object')
		exports["pgnParser"] = factory();
	else
		root["pgnParser"] = factory();
})(this, function() {
return 